import { startTransition, StrictMode, useEffect } from "react";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { replayIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/remix";
import { hydrateRoot } from "react-dom/client";

import { isDevelopment } from "./lib/environment";

if (!isDevelopment()) {
  Sentry.init({
    enabled: process.env.NODE_ENV === "production",
    // dsn: "https://2de2a1700c8885b4785971a75f7935c4@o4507820586762240.ingest.de.sentry.io/4508483368255568",
    environment:
      process.env.SENTRY_ENVIRONMENT || process.env.NODE_ENV || "development",
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      replayIntegration(),
    ],
  });
}

async function enableMocking(): Promise<ServiceWorkerRegistration | undefined> {
  return;
}

enableMocking().then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <RemixBrowser />
      </StrictMode>
    );
  });
});
